"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailButtons = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var _1 = require(".");
var EmailButtons = function () {
    return ((0, jsx_runtime_1.jsxs)(_1.Stack, __assign({ direction: "row", spacing: "2rem", sx: { justifyContent: 'center' } }, { children: [(0, jsx_runtime_1.jsx)(_1.Link, __assign({ href: "https://mail.google.com", target: "_blank" }, { children: (0, jsx_runtime_1.jsx)(_1.ThemedButton, __assign({ variant: "outlined", size: "small" }, { children: "Open Gmail" })) })), (0, jsx_runtime_1.jsx)(_1.Link, __assign({ href: "https://www.icloud.com/mail", target: "_blank" }, { children: (0, jsx_runtime_1.jsx)(_1.ThemedButton, __assign({ variant: "outlined", size: "small" }, { children: "Open Apple Mail" })) })), (0, jsx_runtime_1.jsx)(_1.Link, __assign({ href: "https://outlook.live.com/owa/", target: "_blank" }, { children: (0, jsx_runtime_1.jsx)(_1.ThemedButton, __assign({ variant: "outlined", size: "small" }, { children: "Open Outlook" })) }))] })));
};
exports.EmailButtons = EmailButtons;
